:host {
  display: block;
}

.wishlist {
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
  border-radius: 3px;
  cursor: pointer;

  &.size-sm {
    font-size: 15px;
    width: 19px;
    height: 19px;

    @media (min-width: 768px) {
      font-size: 20px;
      width: 25px;
      height: 23px;
    }
  }

  &.size-md {
    font-size: 24px;
    width: 44px;
    height: 42px;
  }

  &.size-lg {
    font-size: 40px;
    width: 40px;
    height: 40px;

    @media (min-width: 768px) {
      font-size: 40px;
      width: 40px;
      height: 40px;
    }
  }
 
}